// extracted by mini-css-extract-plugin
export default {"dbWrapper":"projDashboard_dbWrapper__em5gh","dashboardRight":"projDashboard_dashboardRight__DTkke"};